import Store from '@/store';
import Axios from 'axios';
import updateToken from '@/middlewares/updateToken-middleware';

const baseDomain = process.env.VUE_APP_API_URL;
const baseURL = `${baseDomain}`;

const Repository = Axios.create({
  baseURL,
});

Repository.interceptors.request.use(async (config) => {
  await Store.dispatch('app/setLoading', true);
  const token = await updateToken();
  config.headers.Authorization = `Bearer ${token}`;
  return config;
}, (error) => {
  Store.dispatch('app/error', { response: error.response });
  Store.dispatch('app/setLoading', false);
  return Promise.reject(error);
});

Repository.interceptors.response.use(async (response) => {
  await Store.dispatch('app/setLoading', false);
  return response;
}, (error) => {
  if (error.request.responseURL.includes('/usuarios/auth') && error.response.status === 403) {
    Store.dispatch('app/setUsuarioNaoCadastrado', true);
  } else {
    Store.dispatch('app/error', { response: error.response });
  }
  Store.dispatch('app/setLoading', false);
  return Promise.reject(error);
});

export default Repository;
